/**
 * Calls play() on an HTMLMediaElement and silences the AbortError that occurs
 * when pause() is called before the play promise resolves (a benign browser
 * race condition). Any other error (e.g. NotSupportedError) is re-thrown so
 * it still surfaces in Sentry.
 */
export function safePlay(el: HTMLMediaElement | null | undefined): void {
  el?.play().catch((err: unknown) => {
    if (err instanceof DOMException && err.name === 'AbortError') return
    throw err
  })
}
